import Loadable from '@townsquare/loadable';
import { notFoundRoute } from '@townsquare/routes/not-found';

const NotFoundLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "not-found-view" */ './FourOhFourPage'),
  loading: () => null,
});

notFoundRoute.component = NotFoundLoadable;
export const notFoundRouterRoute = notFoundRoute;
